
export const ValidateInvoiceInput = (invoice, _createErrorMessage) => {
  if (!invoice) {
    _createErrorMessage("67");
    return false;
  }

  return true;
};
